// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'neueMontreal', 'neueMontreal Fallback'"},"className":"__className_04e056","variable":"__variable_04e056"};